import { NavData } from '@digital-platform/ui-base-components/category-list-nav';

export const categoryMap: NavData = [
  {
    name: 'Regulatory & Compliance',
    id: 'regulatory-compliance',
    link: undefined,
    defaultOpen: false,
    styles: {
      hoverCountColor: '#F7CFB0',
      activeColor: '#FCEFE6',
      color: '#7E3600',
      iconName: 'regulatory-compliance',
    },
    items: [
      {
        name: '',
        id: 'b82b49fa-c470-48b4-ac65-8e8caa0a8fa6', //RLS version
        // id: '1b456993-7e06-4c29-80b0-a8842fe7a23c',
        info: undefined,
        link: undefined,
      },
      {
        name: '',
        id: 'bd81acb5-24f5-4b85-bf90-099eefac633f',
        info: undefined,
        link: undefined,
      },
    ],
  },
  {
    name: 'Services & Spend',
    id: 'services-spend',
    link: undefined,
    styles: {
      hoverCountColor: '#B0C4BE',
      activeColor: '#E6ECEA',
      color: '#002318',
      iconName: 'services-spend',
    },
    items: [
      {
        name: '',
        id: 'eebc7255-08f7-4216-b842-e6f44a3c2025',
        info: undefined,
        link: undefined,
      },
    ],
  },
  {
    name: 'Volume & Diversion',
    id: 'volume-diversion',
    link: undefined,
    styles: {
      hoverCountColor: '#CBE5F8',
      activeColor: '#EEF7FD',
      color: '#2F5F7F',
      iconName: 'volume-diversion',
    },
    items: [
      // {
      //   name: 'Diversion Reports',
      //   id: 'item3.1',
      //   info: undefined,
      //   link: undefined,
      // },
      // {
      //   name: 'Tonnage and Volume',
      //   id: 'item3.2',
      //   info: undefined,
      //   link: undefined,
      // },
    ],
  },
];
